import * as Backbone from 'Backbone';
import _ from 'underscore';
import TPLGererpretsPopUp from '../popUp.tpl.html';
import { CWBaseFormView } from 'core/views/cwForm.view';
import { CWBaseModel } from 'core/models/cwBase.model';
import { CWGererPretsGestion } from '../models/cwGererPretsGestion';
import { i18n } from 'src/i18n.js';
import { UTILS } from 'utils/utils.js';


export class CWGererPretPopUpView extends CWBaseFormView {

  parent: any;
  action: string;
  statut: string;

  constructor(options?: Backbone.ViewOptions<Backbone.Model> | any) {
    options = options || {};
    options.events = _.extend({
      "change :input:not([readonly])": "_change",
      "click button": "_clickListener"
    });
    super(options);
    this.template = TPLGererpretsPopUp;
    this.model = new CWBaseModel({
      value: new CWGererPretsGestion()
    });
    if (options.parent) {
      this.parent = options.parent;
    }
    if (options.action) {
      this.action = options.action;
      this.model.get("value").action = this.action;
    }
    if (options.statut) {
      this.statut = options.statut;
    }
  }

  render(): CWGererPretPopUpView {
    const json = { "i18n": i18n, UTILS: UTILS };
    let comment = "";

    this.$el.append(this.template(json));
    switch (this.action) {
      case "accepter":
        comment = i18n.t('common:gererprets.commentaire_Accept');
        break;
      case "refuser":
        this.$el.find("label[for=commentaire],label[for^=commentaire_uid_]").addClass("cw-required");
        comment = i18n.t('common:gererprets.commentaire_Refus');
        break;
      case "suppression":
        switch (this.statut) {
          case "I":
            comment = i18n.t('common:gererprets.commentaire_SuppresionCours');
            break;
          case "A":
            comment = i18n.t('common:gererprets.commentaire_SuppresionAccept');
            break;
          default:
            comment = i18n.t('common:gererprets.commentaire_SuppresionSupp');
        }
    }
    $(this.el).find(".spanComment").html(comment);
    return this;
  }


  _clickListener(event: any): void {
    const btnClicked = event.currentTarget.value;
    const model = this.model.get("value");

    switch (btnClicked) {
      case "btnOK":
        if (this.action === "accepter") {
          this.parent.model.set("action", "OK");
          this.parent.model.set("commentaire", model.get("commentaire"));
          this.parent.close();
        } else {
          if (this.action === "refuser") {
            model.off("invalid");
            model.on("invalid", this._showValidationErrors, this);

            if (model.isValid()) {
              this.parent.model.set("action", "OK");
              this.parent.model.set("commentaire", model.get("commentaire"));
              this.parent.close();
            }
          } else if (this.action === "suppression") {
            this.parent.model.set("action", "OK");
            this.parent.model.set("commentaire", model.get("commentaire"));
            this.parent.close();
          }
        }
        break;
      case "btnAnnuler":
        this.parent.model.set("action", "annuler");
        this.parent.close();
        break;
      default:
      //Nothing
    }
  }
}
